<template>
  <div class="egl-elm egl-detail setting clearfix">
    <el-form-item :label="$locale('setting.cinema.openAPIjointInfo.sub1')">
      <p class="info-content">{{ detailObj.cinemaToken || "-" }}</p>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.openAPIjointInfo.sub2')">
      <p class="info-content">{{ detailObj.id || "-" }}</p>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.openAPIjointInfo.sub3')">
      <p class="info-content">{{ detailObj.cinemaWebKey || "-" }}</p>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.openAPIjointInfo.sub4')">
      <p class="info-content">{{ detailObj.cinemaSignageKey || "-" }}</p>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.openAPIjointInfo.sub5')">
      <p class="info-content">{{ detailObj.websiteDomain || "-" }}</p>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "open-api-joint-info",
  props: {
    detailObj: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="less">
  .info-content {
    margin: 0;
    color: @primary-black;
    line-height: 1.6;
    word-break: break-all;
  }
</style>